"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.occurrencesInString = exports.occurrenceInString = exports.occurrencesInTokens = exports.occurrenceInTokens = void 0;

var _tokenizers = require("./tokenizers");
/**
 * Gets the occurrence of a subString in a string by using the subString index in the string.
 * @param {Array} tokens
 * @param {Number} currentWordIndex
 * @param {String} subString
 * @return {Object}
 */


var occurrenceInTokens = function occurrenceInTokens(tokens, currentWordIndex, subString) {
  var occurrence = 0;

  for (var i = 0; i <= currentWordIndex; i++) {
    if (tokens[i].token === subString) occurrence++;
  }

  return occurrence;
};
/**
 * Function that count occurrences of a substring in a string
 * @param {Array} tokens - The string to search in
 * @param {String} subString - The sub string to search for
 * @return {Integer} - the count of the occurrences
 */


exports.occurrenceInTokens = occurrenceInTokens;

var occurrencesInTokens = function occurrencesInTokens(tokens, subString) {
  var occurrences = 0;
  tokens.forEach(function (token) {
    if (token && token.token === subString) occurrences++;
  });
  return occurrences;
};
/**
 * Gets the occurrence of a subString in a string by using the subString index in the string.
 * @param {String} text
 * @param {Number} currentWordIndex
 * @param {String} subString
 * @return {Object}
 */


exports.occurrencesInTokens = occurrencesInTokens;

var occurrenceInString = function occurrenceInString(text, currentWordIndex, subString) {
  var tokens = (0, _tokenizers.tokenize)({
    text: text,
    verbose: true
  });
  var occurrence = occurrenceInTokens(tokens, currentWordIndex, subString);
  return occurrence;
};
/**
 * Function that count occurrences of a substring in a string
 * @param {String} text - The string to search in
 * @param {String} subString - The sub string to search for
 * @return {Integer} - the count of the occurrences
 */


exports.occurrenceInString = occurrenceInString;

var occurrencesInString = function occurrencesInString(text, subString) {
  var tokens = (0, _tokenizers.tokenize)({
    text: text,
    verbose: true
  });
  var occurrences = occurrencesInTokens(tokens, subString);
  return occurrences;
};

exports.occurrencesInString = occurrencesInString;